<template>
    <ul class="form-fields list-spaced list-horizontal home-basic-search"  style="list-style-type: none">
        <li class="field-inline-label" ref="regionField">
            <label :for="regionId" class="region-label" style="color:black">County, State, or Zip</label>
            <div>
                <div style="position: relative;">
                    <autocomplete :form-id="regionId"
                                  placeholder="Enter County, State, or Zip"
                                  name="region"
                                  data-source="/json/online-region-autocomplete"
                                  :threshold="3"
                                  sub-value="region_full_name"
                                  ref="region"
                                  :disable-autocomplete="advancedSearchOpen"
                                  :input-string.sync="regionString"
                                  v-on:selected="onRegionAutocompleteSelected"
                                  v-on:input="onRegionInput;"
                                  :key="regionAutocompleteKey"
                    >
                        <template v-slot:suggestionTemplate="item">
                            <table style="width: 100%">
                                <tr>
                                    <td v-bind:style="{ color: (item.item.num_parcels === 0) ? 'gray' : null }">
                                    <span style="font-weight: bold" v-bind:style="{ color: (item.item.num_parcels > 0) ? 'blue' : 'gray' }">
                                        {{ item.item.region_name }}
                                    </span>
                                    </td>
                                    <td style="padding-left: 15px" v-bind:style="{ color: (item.item.num_parcels > 0) ? 'green' : 'gray'}">
                                        {{ item.item.region_type }}
                                    </td>
                                    <td style="padding-left: 4px">
                                    <span v-if="item.item.num_parcels > 0" style="color: darkgreen; font-weight: bold"
                                          :title="'Have data (' + item.item.num_parcels + ' parcels)'">
                                        √
                                    </span>
                                        <span v-else style="color: gray" title="No data">×</span>
                                    </td>
                                </tr>
                            </table>
                        </template>
                    </autocomplete>
                </div>
                <div v-if="regionError" class="validation-message">
                    Region is required
                </div>
            </div>
        </li>
        <li class="field-inline-label">
            <div class="basic-search-type">
                <ul style="text-align: right; list-style-type: none;" >
                    <li>
                        <label for="address" style="color:black">Address</label>
                        <input v-model="selectedOwnerAddressParcelValue" id="address" type="radio" title="Address" name="address_or_owner" value="address" style=" accent-color: #00A916;" checked>
                    </li>
                    <li>
                        <label for="owner" style="color:black">Owner</label>
                        <input v-model="selectedOwnerAddressParcelValue" id="owner" type="radio" title="Owner" name="address_or_owner" value="owner" style="accent-color: #00A916;">
                    </li>
                    <li>
                        <label for="parcel" style="color:black">Parcel ID</label>
                        <input v-model="selectedOwnerAddressParcelValue" id="parcel" type="radio" title="Parcel ID" name="address_or_owner" value="parcel_id" style="accent-color: #00A916;">
                    </li>
                </ul>
            </div>
        </li>
        <li ref="ownerAddressParcelField">
            <autocomplete :form-id="oapId"
                          name="owner_address_parcel"
                          data-source="/json/online-oap-autocomplete"
                          :placeholder="ownerAddressParcelPlaceholder"
                          :threshold="3"
                          sub-value="value"
                          ref="ownerAddressParcel"
                          :key="oapAutocompleteKey"
                          @paste="excelPaste"
                          @beforepaste="excelBeforePaste"
                          :input-string.sync="ownerAddressParcelString"
                          :disable-autocomplete="selectedRegion === '' || advancedSearchOpen"
                          :filters="{region: selectedRegion, ownerAddressParcel: selectedOwnerAddressParcel}">
                <template v-slot:suggestionTemplate="item">
                    <table style="width: 100%">
                        <tr>
                            <td>
                                <span style="font-weight: bold; color: blue">{{ item.item.value }}</span>
                            </td>
                            <td style="padding-left: 15px; text-align: right">{{ item.item.num }}</td>
                        </tr>
                    </table>
                </template>
            </autocomplete>
            <div v-if="ownerAddressParcelError" style="grid-column: none" class="validation-message">
                Address, Owner, or Parcel ID is required
            </div>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "ExplicitRegion",
        props: {
            regionError: Boolean,
            ownerAddressParcelError: Boolean,
            ownerAddressParcel: {
                type: String,
                default: ''
            },
            region: {
                type: String,
                default: ''
            },
            selectedOwnerAddressParcel: {
                type: String,
                default: 'address'
            },
            advancedSearchOpen: Boolean
        },

        watch: {
            regionString(value) {
                if (value.length > 0) {
                    this.$refs.regionField.classList.remove('validation', 'validation-error');
                }
            },
            ownerAddressParcelString(value) {
                if (value.length > 0) {
                    this.$refs.ownerAddressParcelField.classList.remove('validation', 'validation-error');
                }
            }
        },

        computed: {
            regionString: {
                get() { return this.region },
                set(value) { this.$emit('update:region', value) }
            },
            ownerAddressParcelString: {
                get() { return this.ownerAddressParcel },
                set(value) { this.$emit('update:ownerAddressParcel', value) }
            },
            selectedOwnerAddressParcelValue: {
                get() { return this.selectedOwnerAddressParcel },
                set(value) { this.$emit('update:selectedOwnerAddressParcel', value) }
            },
            ownerAddressParcelPlaceholder() {
                switch (this.selectedOwnerAddressParcelValue) {
                    case 'address':
                        return '123 Main St.';
                    case 'owner':
                        return 'Smith, J';
                    case 'parcel_id':
                        return '951-01-001'
                }
                return 'Address, Owner, or Parcel ID';
            }
        },

        data () {
            return {
                regionId: _.uniqueId('region_search'),
                oapId: _.uniqueId('owner-address-parcel'),
                regionAutocompleteKey: _.uniqueId('autocomplete-key'),
                oapAutocompleteKey: _.uniqueId('autocomplete-key'),
                regionSelected: false,
                selectedRegionType: '',
                selectedRegion: '',
            }
        },

        methods: {
            onRegionAutocompleteSelected: function (region) {
                this.selectedRegionType = region.region_type;
                this.selectedRegion = region.region_full_name;
            },
            onRegionInput: function () {
                this.selectedRegionType = '';
                this.selectedRegion = '';
            },
            excelBeforePaste: function (e) {
                if (typeof(e.returnValue) !== "undefined") {
                    e.returnValue = false;
                }
            },
            excelPaste: function (e) {
                if (e.target) {
                    if (typeof(e.clipboardData) !== "undefined" && typeof(e.clipboardData.getData) !== "undefined") {
                        let clipData = e.clipboardData.getData('Text');
                        if (clipData.indexOf('\n') !== -1) {
                            e.preventDefault();
                            this.$nextTick(() => {
                                this.ownerAddressParcelString = clipData.replace(/\r?\n/g,'; ').replace(/;\s+$/,'');
                            })
                            return false;
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .home-basic-search {
        justify-content: center;
        align-items: center;
        display: flex;
    }
    @media only screen and (max-width: 1024px) {
        .region-label {
            width: 50px;
            color: black;
        }
    }
</style>
